import { UserState } from '../../types';
import * as types from './types';

export const setUserInfo = (values: UserState) => {
  return {
    type: types.SET_USER_INFO,
    payload: values,
  };
};
